export default {
  brand: null,
  restId: null,
  alerts: {
    'pmb': {
      complete: [],
      pending: []
    },
    'cc': {
      complete: [],
      pending: []
    },
    'd': {
      complete: [],
      pending: []
    },
    'oa': {
      complete: [],
      pending: []
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/alerts/state.js